import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Form from "./Form";
import dayjs from "dayjs";
import { estadoAusenciaForDropdown, formatCurrency, getLink, getModalidadAusencia, modalidadAusenciaForDropdown, permisions, toast, validarPINSeguridad } from "../../utils/helpers";
import Select from "react-select";
import useFilters from "../../hooks/useFilters";
import { downloadFile, request } from "../../utils/request";
import FiltersContainer from "../general/FiltersContainer";
import Loader from "../general/Loader";
import Pagination from "../general/Pagination";
import Modal from "../general/Modal";
import { apiRequest } from "../../hooks/apiRequest";
import Dropdown from "../general/Dropdown";
import { auth } from "../../utils/auth";

const Ausencias = () => {
    const estadoDefaultValue = [estadoAusenciaForDropdown[5], estadoAusenciaForDropdown[4]];

    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [ausencias, setAusencias] = useState();
    const [ausencia, setAusencia] = useState({});
    const [ausenciaParaBorrar, setAusenciaParaBorrar] = useState({});
    const [tipoAusenciasForDropdown, setTipoAusenciasForDropdown] = useState([]);
    const [categoriasForDropdown, setCategoriasForDropdown] = useState([]);
    const [pinSeguridad, setPinSeguridad] = useState("");

    const { handleFilterChange, filtersQuery } = useFilters({
		desde: null, hasta: null, modalidad: null, tipo: null, estado: estadoDefaultValue.map(item => item.value), categoria: null,
	});

    const getTipos = async () => {
        const response = await request("tipo-ausencia");
        
        setTipoAusenciasForDropdown(response.data.filter((tipo) => tipo.nombre !== "Vacaciones").map((tipo) => ({ value: tipo.id, label: tipo.nombre })));
    };

    const openCreate = (initialState = null) => {
        setAusencia(initialState ?? {
            desde: null,
            modalidad: null,
            cantidad_dia: null,
            contar_sabado: null,
            monto_pagar: null,
            descripcion: null,
            son_adquiridos: null,
            descontar_vacaciones: null,
            tipo_ausencia_id: null,
            empleado: null,
         });

        setShowModal(true);
    };

    const openEdit = (ausencia) => {
        setAusencia({ ...ausencia });

        setShowModal(true);
    };

    const editarOProgramar = (ausencia) => {
        if(ausencia.estado !== 'Pendiente') return openEdit(ausencia);
        
        const tipo = tipoAusenciasForDropdown?.find(option => option.label === "Vacaciones");

        openCreate({
            desde: null,
            modalidad: "normal_pagas",
            cantidad_dia: ausencia.cantidad_dia,
            contar_sabado: null,
            monto_pagar: null,
            descripcion: null,
            son_adquiridos: 0,
            descontar_vacaciones: 1,
            tipo_ausencia_id: tipo.value,
            tipo: { id: tipo.value, nombre: tipo.label },
            empleado: ausencia.empleado,
            estado: ausencia.estado
        });
    };

    const closeModal = () => {
        setAusencia({});

        setShowModal(false);
    };

    const openDelete = (ausencia) => {
        setAusenciaParaBorrar({ ...ausencia });

        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setAusenciaParaBorrar({});

        setShowDeleteModal(false);
    };

    const getAusencias = async (url) => {
        url = url ? url + "&limit=15&clasificacion=general" : `ausencias?limit=15&clasificacion=general`;

        setLoading(true);

		const response = await request(url);

		setAusencias(response);

		setLoading(false);
    };

    const success = (data, nueva) => {
        closeModal();

        if (nueva) openCreate();

        getAusencias(`ausencias${filtersQuery}`);

    };

    const cancel = async () => {
        setDeleting(true);

        if (await validarPINSeguridad(pinSeguridad)) {
            setPinSeguridad("");

            const response = await apiRequest({}, `ausencias/${ausenciaParaBorrar.id}`, 'delete');

            if (response.success) {
                toast("Ausencia Cancelada", "success");
                
                closeDeleteModal();
                
                closeModal();

                await getAusencias(`ausencias${filtersQuery}`);
            } else {
                toast(response.data.message, "error");
            }
        } else {
            toast("PIN incorrecto, intente de nuevo", "error");
        }

        setDeleting(false);
    };

    const getCategorias = async () => {
        const response = await request("taxonomias?relacion=empleados&buscar=");

        const categorias = response.data.map((categoria) => ({ value: categoria.id, label: categoria.nombre }));
        categorias.unshift({ value: "Todos", label: "Todos" })
        categorias.push({ value: "", label: "Sin Categoría" });

        setCategoriasForDropdown(categorias);
    };

    useEffect(() => {
        getTipos();
        getCategorias();
    }, []);

    useEffect(() => {
        getAusencias(`ausencias${filtersQuery}`);
    }, [filtersQuery]);

    useEffect(() => setPinSeguridad(""), showDeleteModal);

    return (
        <>
            <div className='page-header'>
                <h1 className='page-title row'>
                    <span className='col'>Ausencias Generales</span>

                    {auth.can(permisions.reporteAusenciasGeneral) && <Link
                        className='au-btn au-btn-icon au-btn-filter au-btn--small mr-2'
                        to={getLink(
                            `/imprimir/ausencias${filtersQuery}&clasificacion=general`
                            )}
                        target='_blank'>
                        <i className='zmdi zmdi-print' />
                        Imprimir
                    </Link>}

                    {auth.canEdit(permisions.verAusencias) && <button
                        className='au-btn au-btn-icon au-btn--green au-btn--small'
                        onClick={openCreate}>
                        <i className='zmdi zmdi-plus' />
                        NUEVA AUSENCIA
                    </button>}
                </h1>
            </div>

            <FiltersContainer>
                <div className='col'>
                    <label htmlFor='search'>Buscar</label>
                    <input
                        name='buscar'
                        onChange={(e) => handleFilterChange("buscar", e?.target.value)}
                        type='search'
                        placeholder='Buscar...'
                        className='form-control'
                    />
                </div>

                <div className='col'>
                    <label htmlFor='estado'>Estado</label>
                    <Select
                        name='estado'
                        isClearable={true}
                        isMulti
                        onChange={(e) => handleFilterChange("estado", e)}
                        options={estadoAusenciaForDropdown.filter(e => e.value !== "Pendiente")}
                        defaultValue={estadoDefaultValue}
                    />
                </div>

                <div className='col'>
                    <label htmlFor='tipo'>Tipo</label>
                    <Select
                        name='tipo'
                        isClearable={true}
                        onChange={(e) => handleFilterChange("tipo", e?.value)}
                        options={tipoAusenciasForDropdown}
                    />
                </div>

                <div className='col'>
                    <label htmlFor='desde'>Desde</label>
                    <input onChange={(e) => handleFilterChange("desde", e.target.value)}
                        type="date"
                        className='form-control'
                        name='desde'
                        id="desde"
                    />
                </div>

                <div className='col'>
                    <label htmlFor='hasta'>Hasta</label>
                    <input onChange={(e) => handleFilterChange("hasta", e.target.value)}
                        type="date"
                        className='form-control'
                        name='hasta'
                        id="hasta"
                    />
                </div>

                <div className='col'>
                    <label htmlFor='estado'>Categoría</label>
                    <Select
                        name='tipo'
                        isClearable={true}
                        onChange={(e) => handleFilterChange("categoria", e?.value)}
                        options={categoriasForDropdown}
                    />
                </div>
            </FiltersContainer>

            <div className='row'>
                <div className='col-md-12'>
                    <div>
                        <div className='table-data'>
                            <table className='table table-data2'>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Empleado</th>
                                        <th>Tipo</th>
                                        <th>Desde</th>
                                        <th>Hasta</th>
                                        <th style={{width: '60px', padding: '10px 5px'}}>Días</th>
                                        <th>Sábado</th>
                                        <th>Pagar</th>
                                        <th>Descripción</th>
                                        <th>Desc.</th>
                                        <th>Estado</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading
                                        ? (<tr className="tr-shadow"><td colSpan={14}><Loader /></td></tr>)
                                        : (ausencias?.data?.length
                                            ? ausencias.data.map((ausencia) => (
                                                <tr className="tr-shadow" key={ausencia.id}>
                                                    <td style={{maxWidth: '70px', padding: '5px', overflow: 'hidden'}}>
                                                        {ausencia.empleado?.foto && (
                                                            <span className='page-title-foto'>
                                                                <img
                                                                    src={ausencia.empleado.foto}
                                                                    alt={ausencia.empleado.codigo}
                                                                />
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>{ausencia.empleado?.nombreCompleto}</td>
                                                    <td>{ausencia.tipo?.nombre ?? '---'}</td>
                                                    <td>{dayjs(ausencia.desde).format("DD/MM/YYYY")}</td>
                                                    <td>{dayjs(ausencia.hasta).format("DD/MM/YYYY")}</td>
                                                    <td style={{width: '60px', padding: '5px'}}>
                                                        <span title="Total de días">T-{ausencia.cantidad_dia}</span> <br/>
                                                        <span title="Días pendientes">P-{ausencia.restantes?.toString()}</span>
                                                    </td>
                                                    <td>{ausencia.contar_sabado === 0 ? "No Contar" : (ausencia.contar_sabado === 1 ? "Contar 1 Día" : "Contar 1/2 Día")}</td>
                                                    <td>{formatCurrency(ausencia.monto_pagar)}</td>
                                                    <td>
                                                        <div  style={{
                                                            maxWidth: '120px',
                                                            padding: '5px',
                                                            overflowWrap: 'break-word',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            maxHeight: 'calc(1.5em * 3.2)',
                                                            display: 'flex',
                                                        }}>
                                                            {ausencia.descripcion}
                                                        </div>
                                                    </td>
                                                    <td>{ausencia.descontar_vacaciones ? "Si" : "No"}</td>
                                                    <td style={{padding: '5px'}}>
                                                        { ausencia.estado === 'Pendiente' && <span className="badge badge-secondary p-2">Pendiente</span> }
                                                        { ausencia.estado === 'Programadas' && <span className="badge badge-warning text-white p-2">Programadas</span> }
                                                        { ausencia.estado === 'En curso' && <span className="badge badge-info p-2">En curso</span> }
                                                        { ausencia.estado === 'Completada' && <span className="badge badge-success p-2">Completada</span> }
                                                        { ausencia.estado === 'Cancelada' && <span className="badge badge-danger p-2">Cancelada</span> }
                                                    </td>
                                                    { ausencia.cancelada ? <td></td>
                                                        : <td style={{padding: '5px'}}>
                                                        <div className='table-data-feature'>
                                                            <Dropdown
                                                                classes={{ button: "w-100", dropdownMenu: "align-right" }}
                                                                styles={{
                                                                    button: {
                                                                        height: "38px",
                                                                        lineHeight: "0px",
                                                                    },
                                                                    dropdownMenu: {
                                                                        zIndex: "99",
                                                                    },
                                                                }}
                                                            >
                                                                {ausencia.estado !== 'Pendiente' && <Link
                                                                    className='dropdown-item'
                                                                    data-toggle='tooltip'
                                                                    data-placement='top'
                                                                    title=''
                                                                    data-original-title='Print'
                                                                    to={getLink(`/imprimir/ausencias/${ausencia.id}`)}
                                                                    target='_blank'>
                                                                    Imprimir
                                                                </Link>}

                                                                {auth.canEdit(permisions.verAusencias) && <button
                                                                    className='dropdown-item'
                                                                    data-toggle='tooltip'
                                                                    data-placement='top'
                                                                    title=''
                                                                    data-original-title='Edit'
                                                                    onClick={() => editarOProgramar(ausencia) }>
                                                                    {ausencia.estado !== 'Pendiente' ? "Editar" : "Programar"}
                                                                </button>}

                                                                { ausencia.estado !== 'Completada' && ausencia.estado !== 'Pendiente' && <>
                                                                    <button
                                                                        className='dropdown-item'
                                                                        data-toggle='tooltip'
                                                                        data-placement='top'
                                                                        title=''
                                                                        data-original-title='Cancel'
                                                                        onClick={() => openDelete(ausencia) }>
                                                                        Cancelar
                                                                    </button>
                                                                </> }

                                                                {ausencia.documentos?.length >= 1 && <li className="dropdown-divider"></li>}
                                                                {ausencia.documentos?.map(documento => (
                                                                    <a onClick={() => {downloadFile(documento.url, documento.nombre ?? `documento_${documento.id}`)}} className="dropdown-item" rel="noreferrer">
                                                                        {documento.nombre ?? `documento_${documento.id}`}
                                                                    </a>
                                                                ))}
                                                            </Dropdown>
                                                        </div>
                                                    </td> }
                                                </tr>)
                                            )
                                            : (<tr className="tr-shadow"><td colSpan={12}>No hay ninguna Ausencia creada.</td></tr>)
                                        )
                                    }
                                </tbody>
                            </table>

                            {ausencias?.links && (<Pagination links={ausencias.links} meta={ausencias.meta} getData={getAusencias} />)}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={showModal}
                blank={true}
                toggle={() => setShowModal((state) => !state)}>
                <Form
                    ausencia={ausencia}
                    cancel={closeModal}
                    success={success}
                    ondelete={openDelete}
                    esVacaciones={false}
                />
            </Modal>

            <Modal
                title="Cancelar Ausencia"
                show={showDeleteModal}
                blank={false}
                callback={cancel}
                toggle={() => setShowDeleteModal((state) => !state)}>
                    {
                        deleting 
                        ? <><Loader /></> 
                        : <>
                            <p className="px-3 pb-3">¿Estás seguro que desea cancelar esta ausencia? (Esta acción no se puede deshacer).</p>
                    
                            <div className="form-group">
                                <label>PIN de seguridad</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="PIN"
                                    name="pin_seguridad"
                                    value={pinSeguridad}
                                    onChange={(e) =>
                                        setPinSeguridad(e.target.value)
                                    }
                                />
                            </div>
                        </>
                    }
            </Modal>
        </>
    );
};

export default Ausencias;
